import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { dismissNotification } from '../actions.js';

class Header extends Component {

    static propTypes = {
        dispatch: PropTypes.func,
        shopName: PropTypes.string,
        notifications: PropTypes.array
    }

    componentDidMount() {
        // Close the dropdown if the user clicks outside of it
        window.onclick = function (event) {
            let dom = this.refs.dropdownRef;
            if (event.target !== dom && event.target.parentNode !== dom && dom) {
                dom.className = 'prmm-header-dropdown-list-class';
            }
        }.bind(this);
    }

    render() {
        let staticPath = `${process.env.STATIC_PATH}`;

        return (
            <div id='header min-page-with'>
                <div id='prmm-header-container-relative' className='prmm-position-relative'>
                    <div id='prmm-header-container-fixed' style={ { position: 'relative', top: '0px', width: '100%', left: '0px' } }>
                        <div id='prmm-merchant-notification-main'>
                            { this.props.notifications.sort((a, b) => a.display_order - b.display_order).map(notification =>
                                <div key={ notification.display_order } className='prmm-merchant-notification'>
                                    <p className='title'>
                                        <strong>{notification.notification_title}</strong>
                                    </p>
                                    <p dangerouslySetInnerHTML={ {__html: notification.notification_body} } />
                                    <span className='prmm-merchant-notification-icon' onClick={ this.dismiss.bind(this, notification.display_order) } />
                                </div>
                            )}
                        </div>
                        <div className='prmm-header-main'>
                            <div className='prmm-header-global-area'>
                                <div className='prmm-header-main-image' />
                                <div className='prmm-header-text-image' />
                            </div>
                            <div id='prmm-main-nav-bar'>
                                <ul className='nav nav-tabs prmm-header-background-prod' id='prmm-top-site-nav'>
                                    <li id='prmm-header-pull-right' className='pull-right prmm-header-background-prod' >
                                        <div id='prmm-header-dropdown-list' className='prmm-header-dropdown-list-class' tabIndex='1' ref='dropdownRef' onClick={ this.toggleDropdownMenu.bind(this) } >
                                            <span id='prmm-header-dropdown-title'>{ this.props.shopName }</span>

                                            <ul id='prmm-header-dropdown-option' className='dropdown'>
                                                <li><a href='https://ad.rms.rakuten.co.jp/shared/mail'><i className='fa fa-envelope fa-lg' />メール受信設定</a></li>
                                                <li><a href='https://mainmenu.rms.rakuten.co.jp/'><i className='fa fa-sitemap fa-lg' />RMSトップへ</a></li>
                                                <li><a href='https://www.rakuten.co.jp/'><img src={ staticPath + '/rakutenichiba_r.png' } width='19' height='19' />楽天市場へ</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                    <li className='prmm-header-nav-normal-size prmm-header-background-prod'><a className='prmm-header-nav-a-single-line' href='https://ad.rms.rakuten.co.jp/ec/top'>楽天市場広告</a></li>
                                    <li className='prmm-header-nav-normal-size prmm-header-border-left-white prmm-header-background-prod'><a className='multiple-line-tab-name prmm-header-nav-a-triple-line' href='https://ad.rms.rakuten.co.jp/rpp/top'><p>楽天プロモーション<br />プラットフォーム<br />（RPP）</p></a></li>
                                    <li className='prmm-header-nav-normal-size prmm-header-border-left-white prmm-header-background-prod'><a className='prmm-header-nav-a-double-line' href='https://ad.rms.rakuten.co.jp/message'><p>カスタマー<br />マーケティング広告</p></a></li>
                                    <li className='prmm-header-nav-normal-size prmm-header-border-left-white prmm-header-background-prod'><a className='prmm-header-nav-a-single-line' href='https://ad.rms.rakuten.co.jp/cpa/top'>楽天CPA広告</a></li>
                                    <li className='prmm-header-nav-normal-size prmm-header-border-left-white prmm-header-background-prod active'><a className='prmm-header-nav-a-double-line' href='https://ichiba-bs.rms.rakuten.co.jp/rmssson/badsson/'><p>楽天ダイナミック<br />ターゲティング広告</p></a></li>
                                    <li className='prmm-header-nav-normal-size prmm-header-border-left-white prmm-header-background-prod'><a className='prmm-header-nav-a-double-line' href='https://ad.rms.rakuten.co.jp/cpnadv/top'><p>クーポン<br />アドバンス広告</p></a></li>
                                    <li className='prmm-header-nav-normal-size prmm-header-border-left-white prmm-header-background-prod'><a className='prmm-header-nav-a-single-line' href='https://ad.rms.rakuten.co.jp/shared/purchase_summary'>広告購入履歴</a></li>
                                    <li className='prmm-header-nav-normal-size prmm-header-border-left-white prmm-header-background-prod'><a className='prmm-header-nav-a-double-line' href='https://ad.rms.rakuten.co.jp/ec/report_application'><p>パフォーマンス<br />レポートお申し込み</p></a></li>
                                    <li className='prmm-header-border-left-white prmm-header-background-prod'>
                                        <a className='prmm-header-nav-a-single-line' href='https://www.rakuten.co.jp/shops/manual/navi/promotion/07_r002.html'>
                                            <i className='fa fa-question-circle fa-lg' />
                                            <span className='prmm-padding-left-10'>ヘルプ</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div id='prmm-nav-red-bar' />
                    </div>
                </div>
            </div>);
    }

    dismiss = displayOrder => {
        this.props.dispatch(dismissNotification(displayOrder));
    };

    toggleDropdownMenu() {
        let dom = this.refs.dropdownRef;
        if (dom.className === 'prmm-header-dropdown-list-class') {
            dom.className = 'prmm-header-dropdown-list-class active';
        } else {
            dom.className = 'prmm-header-dropdown-list-class';
        }
    }

}

export default Header;
